module.exports = __webpack_public_path__ + "static/pitch_roll_yaw-a5be2bf4ec9183977857a472858e6c80.png";